/* global module, require */
const THREE = require('three'),
	steel = require('../mat/steel'),
	unit = require('../unit');

const xA = unit.mm(36),
	xB = unit.mm(14),
	xC = unit.mm(24),
	xD = unit.mm(26),
	xE = unit.mm(18),
	yA = unit.mm(119.5),
	yB = unit.mm(111.5),
	yC = unit.mm(95),
	yD = unit.mm(80),
	yE = unit.mm(40),
	yF = unit.mm(17);

function makeGeometry(between) {
	const shape = new THREE.Shape([
		new THREE.Vector2(-xA, 0),
		new THREE.Vector2(-xA, yA),
		new THREE.Vector2(-xB, yA),
		new THREE.Vector2(-xB, yB),
		new THREE.Vector2(-xC, yB),
		new THREE.Vector2(-xD, yC),
		new THREE.Vector2(-xE, yD),
		new THREE.Vector2(-xE, yE),
		new THREE.Vector2(-xB, yF),
		new THREE.Vector2(xB, yF),
		new THREE.Vector2(xE, yE),
		new THREE.Vector2(xE, yD),
		new THREE.Vector2(xD, yC),
		new THREE.Vector2(xC, yB),
		new THREE.Vector2(xB, yB),
		new THREE.Vector2(xB, yA),
		new THREE.Vector2(xA, yA),
		new THREE.Vector2(xA, 0),
	]);

	return new THREE.ExtrudeBufferGeometry(shape, {
		depth: between.length(),
		bevelEnabled: false,
	});
}

module.exports = function makePureVista({ start, between }) {
	const mesh = new THREE.Mesh(makeGeometry(between), steel);

	mesh.rotation.y = Math.atan2(between.x, between.z);
	mesh.position.copy(start);

	return mesh;
};
